import { getLogin } from '@/api/login/index'
import {
  getToken,
  setToken,
  removeToken,
  getMark,
  setMark,
  removeMark,
  removeWorkFlowToke
} from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => ({
  token: getToken(),
  mark: getMark(),
  name: '',
  avatar: '',
  accountId: '',
  userInfo: {}
})

const state = getDefaultState()

const mutations = {

  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },

  SET_TOKEN: (state, token) => {
    state.token = token
  },

  SET_NAME: (state, name) => {
    state.name = name
  },

  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  // 设置账号

  SET_ACCOUNTID: (state, accountId) => {
    state.accountId = accountId
  },

  SET_MARK: (state, mark) => {
    state.mark = mark
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
  // user login
  login({ commit }, loginForm) {
    return getLogin(loginForm).then((response) => {
      const data = response.Data_Obj
      localStorage.setItem('userInfo', JSON.stringify(data))
      commit('SET_TOKEN', data.LoginToken)
      commit('SET_MARK', data.loginMark)
      commit('SET_ACCOUNTID', data.UIDstr)
      commit('SET_NAME', data.UserName)
      commit('SET_USER_INFO', data)
      setToken(data.LoginToken)
      setMark(data.loginMark)
    })
  },

  // user logout
  logout({ commit }) {
    console.log('我正在启动logout')
    return new Promise((resolve) => {
      removeToken() // must remove  token  first
      removeWorkFlowToke()
      removeMark()
      resetRouter()
      commit('RESET_STATE')
      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken()
      removeMark()
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
